import { Layout } from 'antd'
// import CustomTabs from '@/layouts/customTabs/customTabs.tsx'
import styles from '@/layouts/index.module.less'
import { useLocation, Outlet } from 'react-router-dom'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import MenuTop from '@/layouts/MenuTop'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import classNames from 'classnames'
import { triggerEvent } from '@/utils/customEvent.ts'

const MicroRoute = forwardRef((props: any, ref) => {
  const location = useLocation()
  const { menus, onUrlChange } = props
  const customTabsRef = useRef<any>({})

  const { menuLevel } = useGlobalStore(
    useShallow((state: any) => ({
      menuLevel: state.menuLevel,
    }))
  )

  const handleScroll = e => {
    triggerEvent('CONTAINER_SCROLL', { event: e.nativeEvent })
  }

  useImperativeHandle(ref, () => ({
    ...customTabsRef.current,
  }))

  return (
    <Layout style={{ borderRadius: '12px', height: '100%',  }}>
      {/*顶部导航栏 */}
      {/*<CustomTabs ref={customTabsRef} menuList={menus} onUrlChang={onUrlChange} />*/}
      { !location.pathname?.startsWith('/data-screen') ? <MenuTop /> : null }

      <Layout
        id="mainContainer"
        className={
          `${styles.layoutRightContent} ${location.pathname?.startsWith('/data-screen') ? styles.dataContainer : null}`
        }
        onScroll={handleScroll}
      >
        <Layout.Content
          style={{
            margin: 0,
            // background: colorBgContainer,
          }}
          className={classNames(styles.layoutRightContentScroll, {
            [styles.menuLevel1]: menuLevel === 1,
          })}
        >
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  )
})

export default MicroRoute
